module.exports = __webpack_public_path__ + "images/bug_turquoise_size_4_46f83c84bd8b62bf022d3d00f893d974.png";